(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('ShoppersConfig', ShoppersConfig);

  function ShoppersConfig(PageConfig, Section, Chart, SeriesService, CalloutLabelService, UserCohort,
                          ConsumerChartDisplay, StandardReports){

    var spu = Section("spu", PageConfig.shoppersSummary,
        Chart("spu", "line", "ratio", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value}),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value})
            ]
        ),
        [ StandardReports.calloutOptions("MeanSPU", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
          CalloutLabelService.sitewide(false)]) ],
        StandardReports.sectionOptions('sessions-per-user')
    );

    var mauSummary = function (section) {
      return Section("mau", PageConfig.shoppersSummary,
          Chart("mau", "line", "values", section,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false })
              ]
          ),
          [ StandardReports.calloutOptions("MeanUserCountUsedForReporting", [ CalloutLabelService.tf(true),
            CalloutLabelService.nonTF(true) ]) ],
          StandardReports.sectionOptions('monthly-users')
      );
    };

    var monthlySessions = function (section) {
      return Section("monthlySessions", PageConfig.shoppersSummary,
          Chart("monthlySessions", "line", "values", section,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false })
              ]
          ),
          [ StandardReports.calloutOptions("MeanMonthlySessions", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true) ]) ],
          StandardReports.sectionOptions('monthly-sessions')
      );
    };

    var sessionForConversion = Section("sessionForConversion", PageConfig.sessions,
        Chart("sessionForConversion", "line", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }) ]
        ),
        [ StandardReports.calloutOptions("TotalUsedForReporting", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true) ]) ],
        StandardReports.sectionOptions('sessions')
    );

    var totalSessions = Section("totalSessions", PageConfig.sessions,
        Chart("totalSessions", "area", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }),
              SeriesService.sitewideWithBots(function (value) { return value.isBot; }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalReporting", [
          CalloutLabelService.sectionTotal(false, UserCohort.all, ConsumerChartDisplay.Colors.totalLine) ]),
          StandardReports.calloutOptions("TotalUsedForReporting", [
            CalloutLabelService.usedForReporting(false, UserCohort.all, ConsumerChartDisplay.Colors.totalLine)])],
        StandardReports.sectionOptions('sessions')
    );

    var tfSessions = Section("tfSessions", PageConfig.sessions,
        Chart("tfSessions", "area", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
              SeriesService.tfWithBots(function (value) { return value.userCohort === UserCohort.tf.value &&
                  value.isBot; }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalReporting", [
          CalloutLabelService.sectionTotal(false, UserCohort.tf, ConsumerChartDisplay.Colors.tfLine) ]),
          StandardReports.calloutOptions("TotalUsedForReporting", [
            CalloutLabelService.usedForReporting(false, UserCohort.tf, ConsumerChartDisplay.Colors.tfLine)])],
        StandardReports.sectionOptions('sessions')
    );

    var nonTFSessions = Section("nonTFSessions", PageConfig.sessions,
        Chart("nonTFSessions", "area", "values", false,
            [ SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }),
              SeriesService.nonTFWithBots(function (value) { return value.userCohort === UserCohort.nonTF.value &&
                  value.isBot; }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalReporting", [
          CalloutLabelService.sectionTotal(false, UserCohort.nonTF, ConsumerChartDisplay.Colors.nonTFLine) ]),
          StandardReports.calloutOptions("TotalUsedForReporting", [
            CalloutLabelService.usedForReporting(false, UserCohort.nonTF, ConsumerChartDisplay.Colors.nonTFLine)])],
        StandardReports.sectionOptions('sessions')
    );

    var mau = Section("mau", PageConfig.activeUsers,
        Chart("mau", "line", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }),
              SeriesService.sitewideWithBots({ userCohort: UserCohort.all.value })
            ]
        ),
        [ StandardReports.calloutOptions("MeanUserCount",
            [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true), CalloutLabelService.sitewideWithBots(false)]) ],
        StandardReports.sectionOptions('monthly-users')
    );

    var mauTF = Section("mauTF", PageConfig.activeUsers,
        Chart("mauTF", "area", "values", false,
            [ SeriesService.siteRegistered({ userCohort: UserCohort.tfSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.tfTravellingReg.value, isBot: false }),
              SeriesService.ipRegistered({ userCohort: UserCohort.tfIPReg.value, isBot: false }) ]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.sectionTotal(false, UserCohort.tf)]),
          StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tfRegistered(true, UserCohort.tfReg),
            CalloutLabelService.siteRegistered(false, UserCohort.tfSiteReg),
            CalloutLabelService.travellingRegistered(false, UserCohort.tfTravellingReg)]),
          StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.ipRegistered(true, UserCohort.tfIPReg)])],
        StandardReports.sectionOptions('monthly-users')
    );

    var dau = Section("dau", PageConfig.activeUsers,
        Chart("dau", "line", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }),
              SeriesService.sitewideWithBots({ userCohort: UserCohort.all.value })
            ]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true),
          CalloutLabelService.sitewideWithBots(false)]) ],
        StandardReports.sectionOptions('daily-users')
    );

    var dauTF = Section("dauTF", PageConfig.activeUsers,
        Chart("dauTF", "area", "values", false,
            [ SeriesService.siteRegistered({ userCohort: UserCohort.tfSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.tfTravellingReg.value, isBot: false }),
              SeriesService.ipRegistered({ userCohort: UserCohort.tfIPReg.value, isBot: false }) ]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.sectionTotal(false, UserCohort.tf)]),
          StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tfRegistered(true, UserCohort.tfReg),
            CalloutLabelService.siteRegistered(false, UserCohort.tfSiteReg),
            CalloutLabelService.travellingRegistered(false, UserCohort.tfTravellingReg)]),
          StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.ipRegistered(true, UserCohort.tfIPReg)])],
        StandardReports.sectionOptions('daily-users')
    );

    var newUsers = Section("newUsers", PageConfig.activeUsers,
        Chart("newUsers", "area", "values", false,
            [ SeriesService.siteRegistered({ userCohort: UserCohort.newTFSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.newTFTravellingReg.value, isBot: false }),
              SeriesService.ipRegistered({ userCohort: UserCohort.newTFIPReg.value, isBot: false }) ]
        ),
        [ StandardReports.calloutOptions("TotalNewUserCounts", [ CalloutLabelService.sectionTotal(false, UserCohort.newTFUsers)]),
          StandardReports.calloutOptions("TotalNewUserCounts", [ CalloutLabelService.tfRegistered(true, UserCohort.newTFReg),
            CalloutLabelService.siteRegistered(false, UserCohort.newTFSiteReg),
            CalloutLabelService.travellingRegistered(false, UserCohort.newTFTravellingReg)]),
          StandardReports.calloutOptions("TotalNewUserCounts", [ CalloutLabelService.ipRegistered(true, UserCohort.newTFIPReg)])],
        StandardReports.sectionOptions('daily-users')
    );

    var adoption = function (section) {
      return Section("adoption", PageConfig.adoption,
          Chart("adoption", "line", "percent", section, [ SeriesService.tf() ]),
          [ StandardReports.calloutOptions("TFPercent", [ CalloutLabelService.tfPercent(false) ], true) ],
          StandardReports.sectionOptions('tf-users-percent', null, '%')
      );
    };

    var tfReg = function (section) {
      return Section("tfReg", PageConfig.adoption,
          Chart("tfReg", "line", "percent", section, [ SeriesService.tf() ]),
          [ StandardReports.calloutOptions("TFPercent", [ CalloutLabelService.tfPercent(false) ], true) ],
          StandardReports.sectionOptions('tf-registered-users-percent', null, '%')
      );
    };

    var tfSessionsAdoption = function (section) {
      return Section("tfSessions", PageConfig.adoption,
          Chart("tfSessions", "line", "percent", section, [ SeriesService.tf() ]),
          [ StandardReports.calloutOptions("TFPercent", [ CalloutLabelService.tfPercent(false) ], true) ],
          StandardReports.sectionOptions('tf-sessions-percent', null, '%')
      );
    };

    var tfOrdersAdoption = function (section) {
      return Section("tfOrders", PageConfig.adoption,
          Chart("tfOrders", "line", "percent", section, [ SeriesService.tf() ]),
          [ StandardReports.calloutOptions("TFPercent", [ CalloutLabelService.tfPercent(false) ], true) ],
          StandardReports.sectionOptions('tf-orders-percent', null, '%')
      );
    };

    var tfRevenue = function (section) {
      return Section("tfRevenue", PageConfig.adoption,
          Chart("tfRevenue", "line", "percent", section, [ SeriesService.tf() ]),
          [ StandardReports.calloutOptions("TFPercent", [ CalloutLabelService.tfPercent(false) ], true) ],
          StandardReports.sectionOptions('tf-revenue-percent', null, '%')
      );
    };

    var kidsMauTF = Section("mauTF", PageConfig.kids,
        Chart("mauTF", "line", "values", false,
            [SeriesService.tfRegistered({ userCohort: UserCohort.tfReg.value, isBot: false }),
              SeriesService.siteRegistered({ userCohort: UserCohort.tfSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.tfTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tfRegistered(false, UserCohort.tfReg),
          CalloutLabelService.siteRegistered(false, UserCohort.tfSiteReg),
          CalloutLabelService.travellingRegistered(false, UserCohort.tfTravellingReg)])],
        StandardReports.sectionOptions('monthly-users-kids')
    );

    var kidsDauTF = Section("dauTF", PageConfig.kids,
        Chart("dauTF", "line", "values", false,
            [SeriesService.tfRegistered({ userCohort: UserCohort.tfReg.value, isBot: false }),
              SeriesService.siteRegistered({ userCohort: UserCohort.tfSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.tfTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tfRegistered(false, UserCohort.tfReg),
          CalloutLabelService.siteRegistered(false, UserCohort.tfSiteReg),
          CalloutLabelService.travellingRegistered(false, UserCohort.tfTravellingReg)])],
        StandardReports.sectionOptions('daily-users-kids')
    );

    var newKidsProfiles = Section("newProfiles", PageConfig.kids,
        Chart("newProfiles", "area", "values", false,
            [SeriesService.siteRegistered({ userCohort: UserCohort.newTFSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.newTFTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("TotalNewProfile", [ CalloutLabelService.tfRegistered(false, UserCohort.newTFReg),
          CalloutLabelService.siteRegistered(true, UserCohort.newTFSiteReg),
          CalloutLabelService.travellingRegistered(true, UserCohort.newTFTravellingReg)])],
        StandardReports.sectionOptions('daily-users-kids')
    );

    var tfUsersWithNewKids = Section("tfUsersWithNewProfiles", PageConfig.kids,
        Chart("tfUsersWithNewProfiles", "line", "values", false,
            [SeriesService.tfRegistered({ userCohort: UserCohort.newTFReg.value, isBot: false }),
              SeriesService.siteRegistered({ userCohort: UserCohort.newTFSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.newTFTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("TotalNewUsersWithProfile", [ CalloutLabelService.tfRegistered(false, UserCohort.newTFReg),
          CalloutLabelService.siteRegistered(false, UserCohort.newTFSiteReg),
          CalloutLabelService.travellingRegistered(false, UserCohort.newTFTravellingReg)])],
        StandardReports.sectionOptions('daily-users-kids')
    );

    var allTimeKidsProfiles = Section("allTimeRecipientProfiles", PageConfig.kids, null,
        [ StandardReports.calloutOptions("TotalNewProfile", [ CalloutLabelService.tfUsersWithRecipient(false, UserCohort.tfAllTime),
          CalloutLabelService.tfUsersWithRecipientSite(false, UserCohort.tfSiteAllTime),
          CalloutLabelService.tfUsersWithRecipientTravelling(false, UserCohort.tfTravellingAllTime)])],
        StandardReports.sectionOptions('daily-users-kids')
    );
    
    var allTimeUserWithKidsProfiles = Section("allTimeWithRecipientProfiles", PageConfig.kids, null,
        [ StandardReports.calloutOptions("TotalNewProfile", [ CalloutLabelService.tfUsersWithRecipient(false, UserCohort.tfAllTime),
          CalloutLabelService.tfUsersWithRecipientSite(false, UserCohort.tfSiteAllTime),
          CalloutLabelService.tfUsersWithRecipientTravelling(false, UserCohort.tfTravellingAllTime)])],
        StandardReports.sectionOptions('daily-users-kids')
    );

    var sfoMauTF = Section("mauTF", PageConfig.sfo,
        Chart("mauTF", "line", "values", false,
            [SeriesService.tfRegistered({ userCohort: UserCohort.tfReg.value, isBot: false }),
              SeriesService.siteRegistered({ userCohort: UserCohort.tfSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.tfTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tfRegistered(false, UserCohort.tfReg),
          CalloutLabelService.siteRegistered(false, UserCohort.tfSiteReg),
          CalloutLabelService.travellingRegistered(false, UserCohort.tfTravellingReg)])],
        StandardReports.sectionOptions('monthly-users-sfo')
    );

    var sfoDauTF = Section("dauTF", PageConfig.sfo,
        Chart("dauTF", "line", "values", false,
            [SeriesService.tfRegistered({ userCohort: UserCohort.tfReg.value, isBot: false }),
              SeriesService.siteRegistered({ userCohort: UserCohort.tfSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.tfTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tfRegistered(false, UserCohort.tfReg),
          CalloutLabelService.siteRegistered(false, UserCohort.tfSiteReg),
          CalloutLabelService.travellingRegistered(false, UserCohort.tfTravellingReg)])],
        StandardReports.sectionOptions('daily-users-sfo')
    );

    var newSFOProfiles = Section("newProfiles", PageConfig.sfo,
        Chart("newProfiles", "area", "values", false,
            [SeriesService.siteRegistered({ userCohort: UserCohort.newTFSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.newTFTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("TotalNewProfile", [ CalloutLabelService.tfRegistered(false, UserCohort.newTFReg),
          CalloutLabelService.siteRegistered(true, UserCohort.newTFSiteReg),
          CalloutLabelService.travellingRegistered(true, UserCohort.newTFTravellingReg)])],
        StandardReports.sectionOptions('daily-users-sfo')
    );

    var tfUsersWithNewSFO = Section("tfUsersWithNewProfiles", PageConfig.sfo,
        Chart("tfUsersWithNewProfiles", "line", "values", false,
            [SeriesService.tfRegistered({ userCohort: UserCohort.newTFReg.value, isBot: false }),
              SeriesService.siteRegistered({ userCohort: UserCohort.newTFSiteReg.value, isBot: false }),
              SeriesService.travellingRegistered({ userCohort: UserCohort.newTFTravellingReg.value, isBot: false })]
        ),
        [ StandardReports.calloutOptions("TotalNewUsersWithProfile", [ CalloutLabelService.tfRegistered(false, UserCohort.newTFReg),
          CalloutLabelService.siteRegistered(false, UserCohort.newTFSiteReg),
          CalloutLabelService.travellingRegistered(false, UserCohort.newTFTravellingReg)])],
        StandardReports.sectionOptions('daily-users-sfo')
    );

    var allTimeSFOProfiles = Section("allTimeRecipientProfiles", PageConfig.sfo, null,
        [ StandardReports.calloutOptions("TotalNewProfile", [ CalloutLabelService.tfUsersWithRecipient(false, UserCohort.tfAllTime),
          CalloutLabelService.tfUsersWithRecipientSite(false, UserCohort.tfSiteAllTime),
          CalloutLabelService.tfUsersWithRecipientTravelling(false, UserCohort.tfTravellingAllTime)])],
        StandardReports.sectionOptions('daily-users-sfo')
    );

    var allTimeUserWithSFOProfiles = Section("allTimeWithRecipientProfiles", PageConfig.sfo, null,
        [ StandardReports.calloutOptions("TotalNewProfile", [ CalloutLabelService.tfUsersWithRecipient(false, UserCohort.tfAllTime),
          CalloutLabelService.tfUsersWithRecipientSite(false, UserCohort.tfSiteAllTime),
          CalloutLabelService.tfUsersWithRecipientTravelling(false, UserCohort.tfTravellingAllTime)])],
        StandardReports.sectionOptions('daily-users-sfo')
    );

    var ageProfiles = Section("age", PageConfig.shopperProfiles,
        Chart("age", "bar", "percent", false, []), [], StandardReports.sectionOptions('age-range')
    );

    var heightProfiles = Section("height", PageConfig.shopperProfiles,
        Chart("height", "bar", "percent", false, []), [], StandardReports.sectionOptions('height-range')
    );

    var weightProfiles = Section("weight", PageConfig.shopperProfiles,
        Chart("weight", "bar", "percent", false, []), [], StandardReports.sectionOptions('weight-range')
    );

    var inseamProfiles = Section("inseam", PageConfig.shopperProfiles,
        Chart("inseam", "bar", "percent", false, []), [], StandardReports.sectionOptions('inseam-range')
    );

    var footLengthProfiles = Section("footLength", PageConfig.shopperProfiles,
        Chart("footLength", "bar", "percent", false, []), [], StandardReports.sectionOptions('foot-length-range')
    );

    var bustSizeProfiles = Section("bustSize", PageConfig.shopperProfiles,
        Chart("bustSize", "bar", "percent", false, []), [], StandardReports.sectionOptions('bust-size-range')
    );

    var torsoLengthProfiles = Section("torsolength", PageConfig.shopperProfiles,
        Chart("torsolength", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var stomachShapeProfiles = Section("stomachshape", PageConfig.shopperProfiles,
        Chart("stomachshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var hipShapeProfiles = Section("hipshape", PageConfig.shopperProfiles,
        Chart("hipshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var thighShapeProfiles = Section("thighshape", PageConfig.shopperProfiles,
        Chart("thighshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var archShapeProfiles = Section("archshape", PageConfig.shopperProfiles,
        Chart("archshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var calfShapeProfiles = Section("calfshape", PageConfig.shopperProfiles,
        Chart("calfshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var breastShapeProfiles = Section("breastshape", PageConfig.shopperProfiles,
        Chart("breastshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var buildProfiles = Section("build", PageConfig.shopperProfiles,
        Chart("build", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );

    var seatShapeProfiles = Section("seatshape", PageConfig.shopperProfiles,
        Chart("seatshape", "column", "percent", false, []), [], StandardReports.sectionOptions('body-shape')
    );



    return {
      spu: spu,
      mauSummary: mauSummary,
      monthlySessions: monthlySessions,

      sessionForConversion: sessionForConversion,
      totalSessions: totalSessions,
      tfSessions: tfSessions,
      nonTFSessions: nonTFSessions,

      mau: mau,
      mauTF: mauTF,
      dau: dau,
      dauTF: dauTF,
      newUsers: newUsers,

      adoption: adoption,
      tfReg: tfReg,
      tfSessionsAdoption: tfSessionsAdoption,
      tfOrdersAdoption: tfOrdersAdoption,
      tfRevenue: tfRevenue,

      kidsMauTF: kidsMauTF,
      kidsDauTF: kidsDauTF,
      newKidsProfiles: newKidsProfiles,
      tfUsersWithNewKids: tfUsersWithNewKids,
      allTimeKidsProfiles: allTimeKidsProfiles,
      allTimeUserWithKidsProfiles: allTimeUserWithKidsProfiles,
      

      sfoMauTF: sfoMauTF,
      sfoDauTF: sfoDauTF,
      newSFOProfiles: newSFOProfiles,
      tfUsersWithNewSFO: tfUsersWithNewSFO,
      allTimeSFOProfiles: allTimeSFOProfiles,
      allTimeUserWithSFOProfiles: allTimeUserWithSFOProfiles,

      ageProfiles: ageProfiles,
      heightProfiles: heightProfiles,
      weightProfiles: weightProfiles,
      inseamProfiles: inseamProfiles,
      footLengthProfiles: footLengthProfiles,
      bustSizeProfiles: bustSizeProfiles,

      torsoLengthProfiles: torsoLengthProfiles,
      stomachShapeProfiles: stomachShapeProfiles,
      hipShapeProfiles: hipShapeProfiles,
      thighShapeProfiles: thighShapeProfiles,
      archShapeProfiles: archShapeProfiles,
      calfShapeProfiles: calfShapeProfiles,
      breastShapeProfiles: breastShapeProfiles,
      buildProfiles: buildProfiles,
      seatShapeProfiles: seatShapeProfiles
    };

  }
})();